import { render, staticRenderFns } from "./mgGoodThings.vue?vue&type=template&id=69c64d27&scoped=true"
import script from "./mgGoodThings.vue?vue&type=script&lang=js"
export * from "./mgGoodThings.vue?vue&type=script&lang=js"
import style0 from "./mgGoodThings.vue?vue&type=style&index=0&id=69c64d27&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69c64d27",
  null
  
)

export default component.exports